var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "left-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 40,
    height: 25,
    fill: "#fd6801"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_131",
    "data-name": "Groupe 131",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_129",
    "data-name": "Groupe 129",
    transform: "translate(0 0)",
    clipPath: "url(#left-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_232",
    "data-name": "Trac\\xE9 232",
    d: "M.247,13.378C.22,13.333.2,13.285.176,13.238s-.046-.087-.064-.133a1.686,1.686,0,0,1-.049-.169c-.011-.042-.026-.083-.034-.127a1.711,1.711,0,0,1-.028-.3S0,12.5,0,12.5s0-.009,0-.014a1.711,1.711,0,0,1,.028-.3c.008-.044.023-.084.034-.127a1.656,1.656,0,0,1,.049-.169,1.44,1.44,0,0,1,.064-.134c.023-.047.043-.094.07-.139a1.582,1.582,0,0,1,.1-.136c.025-.032.044-.066.072-.1L10.231.491A1.431,1.431,0,0,1,12.35.447a1.68,1.68,0,0,1,.041,2.264L5.019,10.9H38.5a1.6,1.6,0,0,1,0,3.2H5.019l7.372,8.188a1.68,1.68,0,0,1-.041,2.264,1.432,1.432,0,0,1-2.119-.044L.419,13.61c-.027-.03-.047-.065-.072-.1a1.582,1.582,0,0,1-.1-.136",
    transform: "translate(0 0)",
    fill: "#fd6801"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.20fd4249dca5a9f52db650ec6bafaf99.svg";
export { ForwardRef as ReactComponent };